import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Provider } from '@angular/core';

import { ErrorLoggerService } from '@ideals/services/error-logger';
import { LOCATION } from '@ideals/types';

export const CHUNK_LOADING_ERRORS: RegExp[] = [
  /Loading chunk [\w-]+ failed/,
  /Failed to fetch dynamically imported module/,
];

export class CustomErrorHandler implements ErrorHandler {
  readonly #errorLoggerService = inject(ErrorLoggerService);
  readonly #location = inject(LOCATION);

  handleError(error: Error | HttpErrorResponse): void {
    if (CHUNK_LOADING_ERRORS.some((chunkError) => chunkError.test(error.message))) {
      this.#location.reload();

      return;
    }

    if (error instanceof Error) {
      this.#errorLoggerService.handleJsError(error);
    }
  }
}

export function provideErrorHandler(): Provider[] {
  return [
    {
      provide: ErrorHandler,
      useClass: CustomErrorHandler,
    },
  ];
}
